module.exports = __webpack_public_path__ + "static/cosi0-9e6e85727f5ad50eb041830dddfa9ff1.jpg";